import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { QuickLinksStore } from 'pages/settings/pages/quickLinks/store/QuickLinksStore'

const QuickLinksContext = createContext<QuickLinksStore | null>(null)

export const useQuickLinksContext = () => {
  const context = useContext(QuickLinksContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with QuickLinksProvider')

  return context
}

export const QuickLinksProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new QuickLinksStore(entities), [])

  useEffect(() => store.dispose, [])

  return <QuickLinksContext.Provider value={store}>{children}</QuickLinksContext.Provider>
}
